module.exports = __webpack_public_path__ + "static/media/logo-jira.e698b97c.svg";